import type { PropsWithChildren } from "react";

type Props = {
    className?: string,

} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function Button({ children, className, ...props }: PropsWithChildren<Props>) {
    return <button {...props} className={mc("group flex justify-center items-center appearance-none outline-none cursor-pointer transition-all duration-250", className ?? '')}>
        <div className="relative overflow-hidden">
            <span className="block h-min group-[&:focus,&:hover]:-translate-y-full transition-all ease-in-out duration-250">{children}</span>
            <span className="absolute top-0 left-0 h-min translate-y-full group-[&:focus,&:hover]:translate-none transition-all ease-in-out duration-250">{children}</span>
        </div>
    </button>
}
